import { baseRestApi } from '@src/utils/rtkQuery';

export interface CrossAssetRiskGroup {
  GroupID?: number;
  Name: string;
  DisplayName?: string;
  ExposureCurrency?: string;
  Description?: string;
  Assets?: string[];
}

const crossAssetRiskGroupsApi = baseRestApi.injectEndpoints({
  endpoints: builder => ({
    getCrossAssetRiskGroups: builder.query<CrossAssetRiskGroup[], void>({
      query: () => ({
        method: 'GET',
        url: '/cross-asset-risk-groups',
        params: { limit: 500 },
        paginateRecords: 10_000,
      }),
    }),
  }),
});

export const { useGetCrossAssetRiskGroupsQuery } = crossAssetRiskGroupsApi;
